// extracted by mini-css-extract-plugin
export var contentClass = "index-module--contentClass--NJMkw";
export var imgClass = "index-module--imgClass--rCl2O";
export var linkClass = "index-module--linkClass--b1a65";